// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQ_root__k6hLQ","title":"FAQ_title__lclJA","details":"FAQ_details__TTTN7"};